const initialStore = {
  loading: true,
  error: false,
  currentQuestionIndex: 0,
  showCASySettings: false,
  WWtKs: []
};

export default initialStore;
